import styled from 'styled-components';

export const ContainerStyle = styled.div`
  position: fixed;
  width: 95%;
  max-width: 600px;
  margin: 0 auto;
  padding-left: 65px;
  z-index: 2000;
  border-radius: 5px;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);

  ${(props) => props.theme.breakpoints.down('sm')} {
    top: 10px;
    padding-left: 0;
  }
`;
